<template>
  <div>
    <v-btn
      v-if="selections && selections.length"
      depressed
      color="error"
      :disabled="downloading"
      class="rounded-1 subtitle-2 text-capitalize me-3"
      @click="$emit('onClear')"
    >
      {{ $t("user.certificatesAndProfileCard.clear") }}
    </v-btn>

    <v-btn
      depressed
      color="primary"
      :loading="downloading"
      :disabled="!selections || !selections.length"
      class="rounded-1 subtitle-2 text-capitalize"
      @click="$emit('onClick')"
    >
      {{ $t("user.certificatesAndProfileCard.download") }}
      {{ selections.length ? `(${selections.length})` : "" }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "BulkDownloadButton",
  props: {
    selections: Array,
    downloading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
